
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[entityType]",
      function () {
        return require("private-next-pages/profile/[entityType]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[entityType]"])
      });
    }
  